import React from 'react';
const noMore = ['No more hours rebuilding lesson plans', 'No more searching for random teaching resources', 'No more explaining difficult maneuvers without visual support', 'No more disconnected lesson ideas', 'No more wondering which skill should come next', 'No more recreating the same explanations over and over', 'No more starting every lesson from an empty page'];
export function FinalCTA() {
  return <section className="py-24 px-4 bg-blue-950 relative overflow-hidden" data-id="element-105" data-mp="m3nflq3slqmd">
      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-106" data-mp="h6n9xgauupvs">
        <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight text-white" data-id="element-107" data-mp="vuruyqxdrdhq">
          Next Week You Can Keep Planning Every Driving Lesson From Scratch...
          <br data-id="element-108" data-mp="qxrq2jc9ogs7" />
          <span className="text-orange-500" data-id="element-109" data-mp="14vfz8twz1zhf">
            Or You Can Open a Complete Teaching System and Already Know Where to Start.
          </span>
        </h2>
        <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-white/5 p-8 rounded-2xl border border-white/15" data-id="element-110" data-mp="zxxznu4ugwm3">
          {noMore.map(item => <div key={item} className="flex items-start gap-3" data-id="element-111" data-mp="2h37weuu3mexi">
              <span className="text-orange-500 mt-0.5" aria-hidden="true" data-id="element-112" data-mp="2h5u5iywn12hu">
                ▸
              </span>
              <span className="text-white/85" data-id="element-113" data-mp="2r1xfus1n87fv">{item}</span>
            </div>)}
        </div>
        <p className="text-xl md:text-2xl font-bold text-white mb-2" data-id="element-114" data-mp="2v3in9xvertio">
          Driving Instructor Ready Does Not Replace Your Experience.
        </p>
        <p className="text-xl text-white/80 mb-6" data-id="element-115" data-mp="301appltoiy14">
          It gives you a system for using that experience with greater:
        </p>
        <p className="text-lg md:text-2xl font-extrabold tracking-widest text-orange-500" data-id="element-116" data-mp="34vog19thieyx">
          STRUCTURE · CLARITY · CONSISTENCY · EFFICIENCY
        </p>
      </div>
    </section>;
}